export const SET_LEVEL = 'LevelSelector/set level';

export const SET_CHAPTER = 'Notebook/Set Chapter';
export const SET_COLLAPSE = 'Notebook/Set Collapse';

//single select, single select color
export const CSCQ_SELECT_OPTION = 'CSCQ/Select Option';
export const CSCQ_SUBMIT = 'CSCQ/Submit';

//multi select
export const MSCQ_SELECT_OPTION = 'MSCQ/Select Option';
export const MSCQ_SUBMIT = 'MSCQ/Submit';

//slider select group
export const GDNDQ_SET_SEQUENCE = 'GDNDQ/Set Sequence';
export const GDNDQ_SUBMIT = 'GDNDQ/Submit';

//slider select
export const DNDQ_SET_SEQUENCE = 'DNDQ/Set Sequence';
export const DNDQ_SUBMIT = 'DNDQ/Submit';

//step select
export const DDQ_SET_OPTION = 'DDQ/Set Option';
export const DDQ_SUBMIT = 'DDQ/Submit';

export const DESIGN_SET_TAB = 'DESIGN/Set Tab';

export const VIEW_THREE_DROP = 'VIEW THREE/Drag & Drop';

export const VIEW_THREE_SET_STEP = 'VIEW THREE/Set step';

export const VIEW_THREE_REMOVE_STEP = 'VIEW THREE/Remove Step';

export const VIEW_THREE_HINT = 'VIEW_THREE/Hint';

export const VIEW_THREE_COMPLETE = 'VIEW THREE/Complete';

export const VIEW_FOUR_DROP = 'VIEW FOUR/Drag & Drop';

export const VIEW_FOUR_SET_STEP = 'VIEW FOUR/Set step';

export const VIEW_FOUR_REMOVE_STEP = 'VIEW FOUR/Remove Step';

export const VIEW_FOUR_HINT = 'VIEW_FOUR/Hint';

export const VIEW_FOUR_COMPLETE = 'VIEW FOUR/Complete';

export const START_TOUR = 'PAGE TOUR/Start Tour';

export const END_TOUR = 'PAGE TOUR/End Step';

export const INCREMENT_TOUR = 'PAGE TOUR/Increment Step';

export const SET_MODAL = 'MODAL/SET MODAL';

export const SHOW_MODAL = 'MODAL/SHOW MODAL';

export const UNDO_MODAL = 'MODAL/UNDO MODAL';
